import { QuotationDTO } from 'components/ordering/quotation/api/dtos/quotation-dto.js'
import { NotFoundError } from 'components/ordering/quotation/api/dtos/error.js'
import { NotFetchedYet } from 'components/ordering/quotation/components/context/quotation-context.js'

export const QuotationUpdateEvent = 'csc-quotation:update'

export const listenForQuotationUpdates = (
  listener: (quotation: QuotationDTO | NotFoundError | NotFetchedYet) => void
): void => {
  const handler = (event: Event) => {
    const detail = (event as CustomEvent).detail
    if (detail && 'quotation' in detail) listener(detail.quotation)
  }
  window.addEventListener(QuotationUpdateEvent, handler as EventListener)
}
